import { url_base } from "./urls"
import axios from 'axios'

export const apiGetAllCotizations = data => () => axios.post(`${url_base}cotizations/all`, data).then(v => v.data).catch(e => ({success: 0, message:"Ha ocurrido un error obteniendo los datos"}))
